import { cloneDeep } from "lodash";
import { allBudgetTypesOptions, allClassificationTypesOptions, allDataSourcesOptions, allMeasureUnitsOptions, allMutuallyRedeemingLevelOptions, allMutuallyRedeemingOptions, allPaymentTypesOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions, allStatusOptions } from "../../common/baseOptions";
import { Classificator } from "../../common/types/Classificator";
import { Transfert } from "../../common/types/Transfert";
import { Template } from "../../common/types/Template";
import { ReportRtFilterSettings } from "./settings/ReportRtFilterSettings";
import { ReportRtFilterOptions } from "./options/ReportRtFilterOptions";
import { Option } from "../../common/types/Option";
import { GenerateByKbkType } from "../../common/types/roots/fields";
import { RepresentationType } from "./data-request/ReportRtTableDataRequest";

export const reportRtTransferts: Transfert[] = [
    { key: 'funding',  active: true, selected: [] },
    { key: 'gu', active: true, selected: [] },
    { key: 'transfer_group', active: true, selected: [] },
    { key: 'direction', active: true, selected: [] },
    { key: 'project', active: true, selected: [] },
]

export const reportRtExpensesClassificators: Classificator[] = [
    { key: 'gr',  active: true, selected: [] },
    { key: 'pgr', active: true, selected: [] },
    { key: 'abp', active: true, selected: [] },
    { key: 'prg', active: true, selected: [] },
    { key: 'ppr', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] },
]


export const reportRtRepresentationTypeOptions: Option<RepresentationType>[] = [
    { value: 'PROJECT_REGION', label: 'Статья-Регион', labelKk: 'Жоба-Аймақ', labelEn: 'Project-Region' },
    { value: 'REGION_PROJECT', label: 'Регион-Статья', labelKk: 'Аймақ-Жоба', labelEn: 'Region-Project' },
]

export const reportRtGenerateByKbkTypeTypeOptions: Option<GenerateByKbkType>[] = [
    { value: 'OwnLevel', label: 'Собственного уровня', labelKk: 'Меншікті деңгей', labelEn: 'Own Level' },
]

// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportRtFilterSettings = {
    // Base:
    reportName: 'RT',
    reportType: 'REGULATED',
    classificationType: 'EXPENSES',
    dataSource: 'LOADER',
    periodicity: 'DAY',
    // Custom:
    date: '',
    region: '',
    paymentType: 'OBLIGATIONS',
    generateByKbk: 'OwnLevel',
    representation: 'PROJECT_REGION',
    budgetTypes: [],
    mutuallyRedeeming: 'WITHOUT',
    mutuallyRedeemingLevels: [],
    statuses: [],
    expenses: [],
    transferts: [],
    measureUnit: 'MILLION',
    roundUpTo: null
}

export const reportRtBaseTemplate: Template = {
    id: null,
    name: 'Разбивка трансфертов',
    excelName: null,
    description: null,
    category: '80',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const reportRtFilterOptions: ReportRtFilterOptions = {
    // Base:
    key: 'RT',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    regions: [], // Загружается с бэка
    paymentTypes: cloneDeep(allPaymentTypesOptions),
    generateByKbkType: cloneDeep(reportRtGenerateByKbkTypeTypeOptions),
    representationType: cloneDeep(reportRtRepresentationTypeOptions),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    statuses: cloneDeep(allStatusOptions),
    expenses: cloneDeep(reportRtExpensesClassificators),
    transferts: cloneDeep(reportRtTransferts),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
}
